import * as types from '../mutation-types';
import {unionState} from '../helpers';

const state = () => ({
    roles: [],
    permissions: [],
});

const actions = {
	fetchAll({commit}) {
		return axios.get('/api/roles').then(response => {
			commit(types.STORE_ROLES, response.data);

			return response.data;
		});
	},

	fetch({commit}, {id}) {
		return axios.get(`/api/roles/${id}`).then(response => {
			commit(types.STORE_ONE_ROLE, response.data);

			return response.data;
		});
    },
    
    fetchPermissions({commit}) {
        return axios.get('/api/roles/permissions').then(response => {
            commit(types.STORE_PERMISSIONS, response.data);

            return response.data;
        });
	},
	
	create({commit}, {name, model, permissions}) {
		return axios.post('/api/roles', {
			name,
			model,
			permissions
		}).then(response => {
			commit(types.STORE_ONE_ROLE, response.data);

			return response.data;
		});
	},

	update({commit}, {id, name, model, permissions}) {
		return axios.put(`/api/roles/${id}`, {
			name,
			model,
			permissions
		}).then(response => {
			commit(types.STORE_ONE_ROLE, response.data);

			return response.data;
		});
	},

	delete({commit}, {id}) {
		return axios.delete(`/api/roles/${id}`).then(() => {
			commit(types.DELETE_ROLE, id);
		});
	}
};

const mutations = {
	[types.STORE_ROLES](state, roles) {
		state.roles = unionState(state.roles, roles);
    },

    [types.STORE_PERMISSIONS](state, permissions) {
        state.permissions = permissions;
    },

    [types.STORE_ONE_ROLE](state, role) {
		state.roles = unionState(state.roles, [role]);
    },

    [types.DELETE_ROLE](state, id) {
        state.roles = state.roles.filter(c => c.id != id);
	},
};

const getters = {
	getById: state => id => state.roles.find(f => f.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};